import React, { FunctionComponent } from 'react';

import useBasePageQuery from '../../hooks/useBasePageQuery';

interface PageTitleProps {
  className?: string;
  truncateAt?: number;
  id?: string;
  variant?: 'screenshot' | 'normal';
}

const TruncatedPageOwnerTitle: FunctionComponent<PageTitleProps> = ({
  className,
  truncateAt,
  id,
  variant,
}) => {
  const { data: basePageData } = useBasePageQuery();

  const title = basePageData?.page?.title;

  return (
    <>
      {title && (
        <h1
          data-qa="page-owner-title"
          className={className}
          id={id}
          style={{
            fontSize:
              title.length < 40 && variant === 'screenshot' ? '2.5em' : '',
          }}
        >
          {truncateAt && title.length > truncateAt
            ? `${title.slice(0, truncateAt)}...`
            : `${title}`}
        </h1>
      )}
    </>
  );
};

export default TruncatedPageOwnerTitle;
